export enum Devices {
  ANDROID = 'android',
  IOS_NON_SAFARI_BROWSER = 'ios-non-safari-browser',
  IOS_SAFARI_BROWSER = 'ios-safari-browser'
}
